export default "__VITE_ASSET__7954dad8__"